import { render, staticRenderFns } from "./add-mapel.vue?vue&type=template&id=4f57adaa&"
import script from "./add-mapel.vue?vue&type=script&lang=js&"
export * from "./add-mapel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports